export default "__VITE_ASSET__qSo6ioqN__"